import "./AnchorOrbitMethod.module.css";
import Header from "@/reusable_sections/Header";
import MethodHeader from "./sections/MethodHeader";
import Narrative from "./sections/Narrative";
import AnchorOrbit from "./sections/AnchorOrbit";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function AnchorOrbitMethodPage() {
  return <div>
      <Header />
      <MethodHeader />
      <Narrative />
      <AnchorOrbit />
      <Consultation />
      <Footer />
    </div>;
}